import { Component, OnInit, OnDestroy } from '@angular/core';
import {formatDate} from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';

import { ProjectsService, ProjectsEditorService } from '@app/services/app/projects.service';
import { AccessProject, AccessProjectKeys } from '@app/models/access';


@Component({
    selector: 'project-details-info-features',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProjectDetailsInfoFeaturesComponent implements OnInit, OnDestroy { 
    private readonly DEFAULT_DUE_TEXT = "Set Due Date";
    private readonly ACTIVE_BLUE_DUE_ICON = "calendar";
    private readonly BLACK_DUE_ICON = "calendar-black";

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;
    public readonly STATUS_ERROR = 3;
    public readonly STATUS_NOT_FOUND = 4;

    protected subs = new Subscription();

    public project: Objects.Request = null;
    public assigners: Array<Objects.User> = [];
    public showCalendar: boolean = false;
    public interactiveAsignee: boolean = false; // prevent action in assignee component
    public interactiveCalendar: boolean = false; // prevent action in calendar component
    public due: any = {
        icon: this.ACTIVE_BLUE_DUE_ICON, // not used
        text: this.DEFAULT_DUE_TEXT
    };

    public actionFeaturesStatus: number = this.STATUS_DONE;
    public warningMessage: string = '';

	constructor(
        private projectsSrv: ProjectsService,
        private editorSrv: ProjectsEditorService
    ){}

	ngOnInit(){ 
        this.subs.add( 
            this.projectsSrv.selectProject().subscribe((project: Objects.Request ) => {
                if(project != null){
                    this.project = project;
                    this.setDuedate();
                }
            })
        );

        this.subs.add( 
            this.editorSrv.selectAssigners().subscribe((users: Objects.User[]) => {
            // console.debug("asigneersssss->", users);
            this.assigners = users;
        }));

        this.subs.add(this.editorSrv.selectAccessAll().subscribe((access: AccessProject) => {
            if(access == null)
                return;
            this.interactiveAsignee = access != null && access.hasOwnProperty(AccessProjectKeys.UPDATE_ASSIGNEE) && access[AccessProjectKeys.UPDATE_ASSIGNEE];
            this.interactiveCalendar = access != null && access.hasOwnProperty(AccessProjectKeys.UPDATE_DUE_DATE) && access[AccessProjectKeys.UPDATE_DUE_DATE];
            this.setDuedate();
        }));

        this.subs.add(this.projectsSrv.selectError('set_project_assigned').subscribe((err: any) => {
            if(err != null){
                // show error
                console.error("Error setting assignee:", err);
                this.setUpdateError(err, 'assignee');
            }
        }));

        this.subs.add(this.projectsSrv.selectError('set_project_due').subscribe((err: any) => {
            if(err != null){
                // show error
                console.error("Error setting due date:", err);
                this.setUpdateError(err, 'due date');
            }
        }));
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    onSelectAssignee(user: Objects.User) {
        if(!this.interactiveAsignee)
            return;
        this.projectsSrv.setAssign(user);
    }

    public toggleCalendar(){
        if(!this.interactiveCalendar)
            return;
        this.showCalendar = !this.showCalendar;
    }

    public onSelectDate(date: string){
        if(!this.interactiveCalendar)
            return;
        this.projectsSrv.setDue(date);
    }

    public onClose(){
        this.showCalendar = false;
    }

    protected setDuedate() {
        // let today: Date = new Date();
        // today.setHours(0,0,0,0);
        // if(this.interactiveCalendar){
        //     this.due.icon = this.ACTIVE_BLUE_DUE_ICON;
        // } else {
        //     this.due.icon = this.BLACK_DUE_ICON;
        // }
        const dueIcon = this.interactiveCalendar ? this.ACTIVE_BLUE_DUE_ICON : this.BLACK_DUE_ICON;
        if(this.project.due_date == null) {
            this.due = {
                icon: dueIcon,
                text: this.DEFAULT_DUE_TEXT
            };

            return;
        } 
       
        // let dueDate: Date = new Date(this.project.due_date);
        // dueDate.setHours(0,0,0,0);
        // let formattedDate = formatDate(dueDate,'dd MMM yyyy', 'en_US');
        // this.due.text = formattedDate;

        // fix 2024/07/17 <rafael@twonas.com>
        // fix utc date
        let dateSplitted = this.project.due_date.split("-");
        console.log("split", dateSplitted);
        // ATENTION:: Javascript month start in 0!!!!!!!!!!!! https://www.youtube.com/watch?v=sBlY53fgN-k
        let month = new Date(Number(dateSplitted[0]), Number(dateSplitted[1])-1, 15); // day 15 in the middle of the month        
        this.due.text = dateSplitted[2] + formatDate(month,' MMM yyyy', 'en_US');
        this.due.icon = dueIcon;
    }


    // action when push modal buton when error
    onUpdateFeaturesError() {
        this.actionFeaturesStatus = this.STATUS_DONE;
    }

    protected setUpdateError(error: HttpErrorResponse, feature: string  = 'property') {
    
            if(error == null)
                return;

            this.warningMessage = "There was an error updating this project.";
            switch(error.status) {
                case 500:
                case 400:
                    this.actionFeaturesStatus = this.STATUS_ERROR;
                    break;
                case 404:
                    this.actionFeaturesStatus = this.STATUS_NOT_FOUND;
                    break;
                case 403:
                    this.actionFeaturesStatus = this.STATUS_NOT_ALLOWED;
                    this.warningMessage = "The project " + feature + " could NOT be updated.";
                    break;
            }
            // any update error wil reload the project to its real data.
            // this.projectsSrv.load(this.project.id);
        }
}